import { makeStyles } from '@mui/styles';
 
const styles = (theme) => ({
 
  container: () => {
    return  {
       width: '100%',
       height: 'auto !important',
       display: 'flex !important',

       alignItems: 'left',
       boxSizing: 'border-box',
       border: '1px solid #C3C3C3',
       borderRadius: '6px',

       '&.MuiFormControl-root': {
        marginTop: '12px',
        marginBottom: '6px',
       },
       
       '& .MuiFormLabel-root': {
        fontSize: '12px',
        color: '#0C0644',
        fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,

        '&.Mui-focused': {
          color: '#0C0644',
        }
       },

    };
  },
 
  groupRoot: () => {
    return  {
      width: '100%',
      display: 'flex !important',
      marginLeft: '8px',
      height: 'auto',

      '& .MuiFormControlLabel-root': {

        '& .MuiTypography-root': {
          fontSize: '12px',
          letterSpacing: '0',
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
        },

      },
   };
  },

  unselected: {
   display: 'flex',
    minWidth: '16px',
    boxSizing: 'border-box',
    width: '16px',
    height: '16px',
    borderRadius: '8px',
    border: '1px solid #666666',
  },

  selected: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    borderRadius: '8px',
    border: '1px solid #0C0644',
    backgroundColor: '#F1F1F1',

    '& .MuiSvgIcon-root ': {
      fontSize: '8px',
      fill: '#0C0644',
    }
  },

  radioItem: {
    height: '30px',
  },
});

export default styles;
export const useStyles = makeStyles(styles);
